import React from 'react';
import {HomeEnum} from 'presentation/constants';
import {Navigate} from 'react-router-dom';
import {HealthCardLayout} from './components/HealthCardLayout';
import {useAccountInformation} from '../hooks';

export function HealthCardPage() {
	const {isResponsibleWithoutBenefits} = useAccountInformation();

	if (isResponsibleWithoutBenefits) {
		return <Navigate to={HomeEnum.HOME_PAGE} />;
	}

	return <HealthCardLayout />;
}
